import React from 'react';
import PropTypes from 'prop-types';
import Carousel, { Modal as ReactImagesModal, ModalGateway } from 'react-images';
import View from './View';
import Header from './Header';
import LoadingIndicator from '../LoadingIndicator';

const modalCustomStyles = {
  blanket: base => ({
    ...base,
    zIndex: 1200
  }),
  positioner: base => ({
    ...base,
    zIndex: 1201,
    '& .react-images__navigation button': {
      position: 'fixed',
      backgroundColor: 'rgba(85,85,85,0.2)'
    },
    '& .react-images__navigation button:hover': {
      position: 'fixed',
      backgroundColor: 'rgba(0,0,0,0.2)'
    }
  })
};

const Modal = ({ images, onClose, carouselProps }) => {
  if (!images || images.length === 0) {
    return (
      <ModalGateway>
        <ReactImagesModal onClose={onClose}>
          <LoadingIndicator />
        </ReactImagesModal>
      </ModalGateway>
    );
  }

  return (
    <ModalGateway>
      <ReactImagesModal onClose={onClose} styles={modalCustomStyles}>
        <Carousel
          hideControlsWhenIdle={false}
          currentIndex={0}
          views={images}
          components={{ View, Header }}
          {...carouselProps}
        />
      </ReactImagesModal>
    </ModalGateway>
  );
};

Modal.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      source: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
      caption: PropTypes.string
    })
  ),
  onClose: PropTypes.func.isRequired,
  carouselProps: PropTypes.object
};

Modal.defaultProps = {
  images: [],
  carouselProps: {}
};

export default Modal;
